import { useState, useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import CountdownTimer from "@/components/CountdownTimer";
import { ArrowDown } from "lucide-react";

const HERO_BG = "https://customer-assets.emergentagent.com/job_ai-photo-builder-2/artifacts/gnlai3og_Crie%20imagens%20de%20estudio%20com%20IA%20A%20metodologia%20Advanse%20IA%20transforma%20qualquer%20pessoa%20em%20um%20profissional%20de%20fotografia%20de%20estudio%20usando%20inteligencia%20artificial.%20Sem%20equipamento%20caro.%20Sem%20estudio%20fis%20%281%29.webp";
const HERO_BG_MOBILE = "https://customer-assets.emergentagent.com/job_ai-photo-builder-2/artifacts/00c81lts_%2B%20fotografia%20de%20estudio%20usando%20inteligencia%20artificial.%20Sem%20equipamento%20caro.%20Sem%20estudio%20fisico..webp";

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden"
    >
      {/* Desktop: full background with overlay */}
      <div className="hidden md:flex relative min-h-screen items-end justify-center">
        <div className="absolute inset-0 z-0">
          <img
            src={HERO_BG}
            alt="Advanse IA - Crie imagens de estudio com IA"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black" />
        </div>
        <div className="absolute inset-0 z-[1] scan-line pointer-events-none" />
        <div className="relative z-10 max-w-7xl mx-auto px-12 text-center pb-16 pt-24">
          <div className={`transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <a href="#register">
              <Button
                data-testid="hero-cta-button"
                className="bg-[#00FF00] text-black font-semibold hover:bg-[#33FF33] rounded-none px-10 h-14 text-base tracking-wide shadow-[0_0_20px_rgba(0,255,0,0.2)] hover:shadow-[0_0_30px_rgba(0,255,0,0.4)] transition-all duration-300 animate-pulse-glow"
              >
                GARANTIR MINHA VAGA
              </Button>
            </a>
          </div>
          <div className={`mt-12 transition-all duration-1000 delay-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <p className="font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-white/40 mb-6">
              Inscricoes encerram em
            </p>
            <CountdownTimer targetDate="2026-04-15T23:59:59" />
          </div>
          <div className={`mt-12 transition-all duration-1000 delay-700 ${visible ? 'opacity-100' : 'opacity-0'}`}>
            <a href="#preview" className="inline-flex flex-col items-center gap-2 text-white/30 hover:text-[#00FF00] transition-colors">
              <span className="text-xs font-['JetBrains_Mono'] tracking-wider">EXPLORAR</span>
              <ArrowDown size={16} className="animate-bounce" />
            </a>
          </div>
        </div>
      </div>

      {/* Mobile: image block + content below */}
      <div className="md:hidden flex flex-col bg-black">
        <div className="relative w-full">
          <img
            src={HERO_BG_MOBILE}
            alt="Advanse IA - Crie imagens de estudio com IA"
            className="w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/80" />
        </div>
        <div className="px-6 pb-10 -mt-8 relative z-10 text-center">
          <div className={`transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <a href="#register">
              <Button
                data-testid="hero-cta-button-mobile"
                className="bg-[#00FF00] text-black font-semibold hover:bg-[#33FF33] rounded-none px-8 h-12 text-sm tracking-wide shadow-[0_0_20px_rgba(0,255,0,0.2)] animate-pulse-glow"
              >
                GARANTIR MINHA VAGA
              </Button>
            </a>
          </div>
          <div className={`mt-8 transition-all duration-1000 delay-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <p className="font-['JetBrains_Mono'] text-[10px] uppercase tracking-[0.2em] text-white/40 mb-4">
              Inscricoes encerram em
            </p>
            <CountdownTimer targetDate="2026-04-15T23:59:59" />
          </div>
        </div>
      </div>
    </section>
  );
}
